import { makeAutoObservable } from 'mobx';

class ConfirmDialogStore {
  message = '';
  title = '';
  open = false;
  isProcessing = false;
  confirmAction: (() => Promise<void> | void) | null = null;
  closeAction: (() => void) | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setIsProcessing(isProcessing: boolean) {
    this.isProcessing = isProcessing;
  }

  show(
    title: string,
    text: any,
    confirmAction: (() => Promise<void> | void) | null = null,
    closeAction: (() => void) | null = null
  ) {
    this.title = title;
    this.message = text;
    this.confirmAction = confirmAction;
    this.closeAction = closeAction;
    this.open = true;
    this.isProcessing = false;
  }

  close() {
    this.open = false;
    this.confirmAction = null;
    this.closeAction = null;
    this.isProcessing = false;
    this.title = '';
    this.message = '';
  }
}

export const confirmDialogStore = new ConfirmDialogStore();
